<template>
    <div id="app"
         :class="[$route.params.slug ? $route.params.slug : 'main', {activeRtl: $store.state.rtl}, $route.name, isHalloween && isEventAllowedOnPage ? 'halloween' : '', isChristmas && isEventAllowedOnPage ? 'christmas' : '', isEaster && isEventAllowedOnPage ? 'easter' : '']">

        <lucky-wheel v-if="isLuckyWheelEnabled"/>

        <maintenance-mode v-if="$store.state.maintenanceMode"/>

        <error-mode v-else-if="$store.state.errorMode"/>

        <app-content v-else/>

        <event-halloween v-if="isHalloween && !$store.state.errorMode && !$store.state.maintenanceMode"/>

        <event-christmas v-if="isChristmas && !$store.state.errorMode && !$store.state.maintenanceMode"/>

        <event-easter v-if="isEaster && !$store.state.errorMode && !$store.state.maintenanceMode"/>
    </div>
</template>

<script>
import {events, luckWheelEnabled, siteRedirectionIfOpenInIFrame} from "../config/app";
import Toaster from "./mixins/toaster";
import {luckyWheelExcludedRoutes, eventExcludedRoutes} from "./interfaces/routeInterface";

export default {
    name: "App",

    mixins: [Toaster],

    mounted() {
        if(siteRedirectionIfOpenInIFrame && window.self !== window.top) {
            this.redirectToHome();
        }
    },

    computed: {
        isHalloween() {
            return events.halloween;
        },

        isChristmas() {
            return events.christmas;
        },

        isEaster() {
            return events.easter;
        },

        isLuckyWheelEnabled() {
            return (this.$store.getters.getAvailableFortuneWheelSpinsCount() || this.isFortuneWheelOpened) && luckWheelEnabled && this.isLuckyWheelAllowedOnPage;
        },

        isEventAllowedOnPage() {
            return !eventExcludedRoutes.includes(this.$route.name);
        },

        isLuckyWheelAllowedOnPage() {
            return !luckyWheelExcludedRoutes.includes(this.$route.name);
        },

        isFortuneWheelOpened() {
            return this.$store.state.dialogs.fortuneWheel;
        },
    },

    methods: {
        redirectToHome() {
            let redirectRoute = this.$router.resolve({
                path: '/',
                params: {locale: this.$store.state.locale}
            });

            top.window.location.href = redirectRoute.resolved.fullPath;
        },
    },
}
</script>